import Constant from "../../../utils/constant";

/**
 * PLP-6459: Pre-Tests and Post-Tests are diagnostics. The customer app shows them by a name
 * built from their subject and type, so the CMS stores that name and keeps it read-only.
 */
export const isDiagnosticTestType = (cannedTestTypeId: unknown): boolean => {
  const typeId = Number(cannedTestTypeId);
  return (
    typeId === Constant.CANNED_TEST_TYPE.PRE_TEST ||
    typeId === Constant.CANNED_TEST_TYPE.POST_TEST
  );
};

/**
 * The name the Assessment Bank shows for a diagnostic
 * (SPA getPremiumAssessmentNameWithSubjectPrefix), e.g.
 * "1st Grade Math (TEKS) - Diagnostic Pre-Test". Undefined when either label is missing,
 * so a partial name is never written. The dropdown handlers store a missing label as 0.
 */
export const buildDiagnosticTestName = (
  subjectName: unknown,
  cannedTestTypeName: unknown
): string | undefined => {
  if (
    typeof subjectName !== "string" ||
    typeof cannedTestTypeName !== "string" ||
    subjectName.trim() === "" ||
    cannedTestTypeName.trim() === ""
  ) {
    return undefined;
  }
  return `${subjectName} - Diagnostic ${cannedTestTypeName}`;
};
